import { SEND_KHATA_INVOICE } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface RecordingResponse {
    reason: string;
    status: string;
    url: string;
}

export default (
    khataTxnId: string,
    gstNumber?: string,
): Promise<{ success: boolean; url?: string; error?: string }> => {
    return fetchWithRefresh(SEND_KHATA_INVOICE, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            khataTxnId,
            gstNumber,
        }),
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('generate khata invoice Api had an error');
        }
    });
};
